const NTIA_FEATURE_ENABLED = 'organization-firmware-ntia'
const CONFIGURATION_SETS_FEATURE_ENABLED = 'organization-configuration-sets'
const ASSETS_PAGE_FEATURE_ENABLED = 'organization-assets-page'
const ADVANCED_RELAYS_ENABLED = 'organization-advanced-relays'
const NEXTGEN_FREQUENCY_SETS_ENABLED = 'organization-nextgen-frequency-sets'
const DIAGNOSTIC_LOGS_ENABLED = 'organization-diagnostic-logs'
const ENCRYPTION_KEY_EXPORT_ENABLED = 'organization-encryption-key-export'

export default Object.freeze({
    NTIA_FEATURE_ENABLED,
    CONFIGURATION_SETS_FEATURE_ENABLED,
    ASSETS_PAGE_FEATURE_ENABLED,
    ADVANCED_RELAYS_ENABLED,
    NEXTGEN_FREQUENCY_SETS_ENABLED,
    DIAGNOSTIC_LOGS_ENABLED,
    ENCRYPTION_KEY_EXPORT_ENABLED,
})
